import { ChangeDetectionStrategy, Component, computed, input, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PlotlyModule } from 'angular-plotly.js';
import { ProductionBatch, InspectionModel } from '../../../model';

@Component({
  selector: 'app-batch-radar-plot',
  standalone: true,
  imports: [CommonModule, PlotlyModule],
  template: `
    <div class="plot-container">
      <plotly-plot [data]="plotData()" [layout]="plotLayout()" [config]="plotConfig()" [style]="{ width: '100%', height: '100%' }"></plotly-plot>
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
        height: 400px;
        width: 100%;
      }
      .plot-container {
        width: 100%;
        height: 100%;
      }
    `,
  ],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BatchRadarPlotComponent {
  batch = input.required<ProductionBatch>();
  model = input<InspectionModel | null>(null);

  plotData = computed(() => {
    const b = this.batch();
    if (!b) return [];

    // Valid metrics to show on radar
    return [
      {
        type: 'scatterpolar',
        r: [b.dEAvg, b.dEMax, b.dCAvg, b.dCMax, b.dENatAvg, b.dENatMax],
        theta: ['dE Avg', 'dE Max', 'dC Avg', 'dC Max', 'dE Nat Avg', 'dE Nat Max'],
        fill: 'toself',
      },
    ];
  });

  plotLayout = computed(() => {
    return {
      polar: {
        radialaxis: {
          visible: true,
          range: [0, 5], // Adjust range based on expected delta values
        },
      },
      showlegend: false,
      margin: { l: 40, r: 40, b: 20, t: 20 },
    };
  });

  plotConfig = computed(() => {
    return {
      responsive: true,
      displayModeBar: false,
    };
  });
}
